import React from 'react';
import { ImageBadge, VideoTile } from 'seduo-ui';
const Example = () => (<VideoTile title="Program test with log text and multiple course" lector="Unnamed lector" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" video={{
        src: 'https://lmc-vod.ssl.cdn.cra.cz/0143/9518/cze-hd2-s0U5SoTh.mp4',
        type: 'video/mp4',
    }} overlay={{
        bottomLeft: (<>
                    <ImageBadge text="4 kurzy"/>
                    <ImageBadge text="1h 55min"/>
                </>),
        topLeft: <ImageBadge icon="education" text="Vzdělávací program" theme="dark"/>,
    }}/>);
export default Example;
